import React from 'react'
import RoadBookingSegment from './RoadBookingSegment'
import RoadBookingSeats from './RoadBookingSeats'

const RoadBookingSelection = () => (
  <div>
    <RoadBookingSegment />
    <RoadBookingSeats />
  </div>
)

export default RoadBookingSelection
